if (!customElements.get('product-form')) {
	customElements.define(
		'product-form',
		class ProductForm extends HTMLElement {
			constructor() {
				super()

				try {
					this.form = this.querySelector('form')
					this.form.querySelector('[name="id"]').disabled = false
					this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
					this.cart =
						document.querySelector('cart-drawer') ||
						document.querySelector('cart-items')
					this.submitButton = this.querySelector('[type="submit"]')
					if (document.querySelector('cart-drawer'))
						this.submitButton.setAttribute('aria-haspopup', 'dialog')
					this.hideErrors = this.dataset.hideErrors === 'true'
				} catch (error) {}
			}

			onSubmitHandler(evt) {
				evt.preventDefault()
				if (this.submitButton.getAttribute('aria-disabled') === 'true') return

				this.handleErrorMessage()
				this.submitButton.setAttribute('aria-disabled', true)
				this.submitButton.classList.add('loading')
				this.querySelector('.loading-overlay__spinner').classList.remove(
					'hidden',
				)

				const config = fetchConfig('javascript')
				config.headers['X-Requested-With'] = 'XMLHttpRequest'
				delete config.headers['Content-Type']

				const formData = new FormData(this.form)
				if (this.cart) {
					formData.append(
						'sections',
						this.cart.getSectionsToRender().map(section => section.id),
					)
					formData.append('sections_url', window.location.pathname)
					this.cart.setActiveElement(document.activeElement)
				}
				if (document.querySelector('.product_compatible_accessories_block')) {
					document
						.querySelectorAll('.compatible_accessorie_checkbox:checked')
						.forEach((item, index) => {
							formData.set(`items[${index}]id`, item.value)
							formData.set(`items[${index}]quantity`, '1')
						})
				}
				config.body = formData

        // 新增逻辑
        if (document.querySelector(".yg-accessories-button.added")) {
          document.querySelectorAll(".yg-accessories-button.added").forEach((item,index)=>{
            formData.set(`items[${index}]id`, item.getAttribute('data-variant-id'));
            formData.set(`items[${index}]quantity`, '1');
          })
        }

				fetch(`${routes.cart_add_url}`, config)
					.then(response => response.json())
					.then(response => {
						if (response.status) {
							document.dispatchEvent(
								new CustomEvent('afterAddCartError', {
									detail: {
										productVariantId: formData.get('id'),
										errors: response.errors || response.description,
										message: response.message,
									},
								}),
							)
							this.handleErrorMessage(response.description)
							const soldOutMessage =
								this.submitButton.querySelector('.sold-out-message')
							if (!soldOutMessage) return
							this.submitButton.setAttribute('aria-disabled', true)
							this.submitButton.querySelector('span').classList.add('hidden')
							soldOutMessage.classList.remove('hidden')
							this.error = true
							return
						} else if (!this.cart) {
							window.location = window.routes.cart_url
							return
						}
						if (!this.error) {
							this.error = false
							pushSuccessMessage(window.cartStrings.success)
							const quickAddDrawer = this.closest('quick-add-drawer')
							if (quickAddDrawer) {
								document.body.addEventListener(
									'drawerClosed',
									() => {
										setTimeout(() => {
											this.cart.renderContents(response)
										})
									},
									{ once: true },
								)
								quickAddDrawer.close()
							} else {
								this.cart.renderContents(response)
							}
							document.dispatchEvent(
								new CustomEvent('afterCartChanged', {
									detail: { productVariantId: formData.get('id') },
								}),
							)
						}
					})
					.catch(e => {
						console.error(e)
					})
					.finally(() => {
						this.submitButton.classList.remove('loading')
						if (this.cart && this.cart.classList.contains('is-empty'))
							this.cart.classList.remove('is-empty')
						if (!this.error) this.submitButton.removeAttribute('aria-disabled')
						this.querySelector('.loading-overlay__spinner').classList.add(
							'hidden',
						)
					})
			}

			handleErrorMessage(errorMessage = false) {
				if (this.hideErrors) return
				this.errorMessageWrapper =
					this.errorMessageWrapper ||
					this.querySelector('.product-form__error-message-wrapper')
				if (errorMessage && !this.errorMessageWrapper) {
					pushErrorMessage(errorMessage)
				}
				if (!this.errorMessageWrapper) return
				this.errorMessage =
					this.errorMessage ||
					this.errorMessageWrapper.querySelector('.product-form__error-message')

				this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage)

				if (errorMessage) {
					this.errorMessage.textContent = errorMessage
				}
			}
		},
	)
}
